import React from 'react';

import PDFViewer from '@/components/FileViewers/PDFViewer/PDFViewer';
import AudioPlayer from '@/components/FileViewers/Player/AudioPlayer';
import VideoPlayer from '@/components/FileViewers/Player/VideoPlayer';
import { IpfsFilePreviewProps } from 'interfaces/IpfsHashList/FileListing';

import ThreeDViewer from '../FileViewers/3dViewer/ThreeDViewer';
import CSVViewer from '../FileViewers/CSVViewer/CSVViewer';
import DefaultFilePreview from '../FileViewers/DefaultFilePreview/DefaultFilePreview';
import IPFSTextFileViewer from '../FileViewers/IPFSTextFileViewer/IpfsTextFileViewer';
import PlainTextViewer from '../FileViewers/PlainTextViewer/PlainTextViewer';
import XLSXViewer from '../FileViewers/XLSXViewer/XLSXViewer';

const IpfsFilePreview = ({
  filePreviewURL,
  activeFile,
}: IpfsFilePreviewProps) => {
  const mimetype = filePreviewURL?.type;
  const downloadUrl = filePreviewURL?.url;
  const renderFile = () => {
    if (
      mimetype === 'gltf' ||
      mimetype === 'glb' ||
      activeFile.includes('.glb') ||
      activeFile.includes('.gltf')
    ) {
      return <ThreeDViewer url={downloadUrl} />;
    }
    if (mimetype === 'application/pdf')
      return (
        <div
          className="h-[500px] overflow-auto no-scrollbar flex flex-col justify-center 
    items-center lg:h-full w-full bg-[#525659]"
        >
          <PDFViewer url={downloadUrl} />
        </div>
      );

    if (mimetype === 'application/json')
      return (
        <div className="w-full h-full overflow-y-auto no-scrollbar">
          <IPFSTextFileViewer url={downloadUrl} />
        </div>
      );

    if (mimetype === 'text/csv')
      return (
        <div className="w-full h-full overflow-hidden border">
          <CSVViewer url={downloadUrl} />
        </div>
      );

    if (mimetype === 'xlsx') return <XLSXViewer url={downloadUrl} />;

    if (mimetype === 'text/plain' || mimetype === 'text/html') {
      return <PlainTextViewer url={downloadUrl} />;
    }

    if (mimetype?.includes('audio'))
      return (
        <div className="w-full h-full">
          <AudioPlayer url={downloadUrl} mimetype={mimetype} />
        </div>
      );

    if (mimetype?.includes('image'))
      return (
        <div className="w-full  h-full p-4 flex justify-center items-center">
          <img
            src={downloadUrl}
            alt="img"
            className="rounded-[6px] max-h-full"
          />
        </div>
      );

    if (mimetype?.includes('video'))
      return (
        <div className="w-full h-full p-4 flex justify-center items-center">
          <VideoPlayer url={downloadUrl} mimetype={mimetype} />
        </div>
      );

    return <DefaultFilePreview url={downloadUrl} mimetype={mimetype} />;
  };
  return (
    <section
      className="h-full relative w-full bg-white rounded-[8px]
     box-border overflow-y-scroll no-scrollbar p-2"
    >
      {renderFile()}
    </section>
  );
};

export default IpfsFilePreview;
